import styled from 'styled-components';
import { colours, fonts } from '../../styles/theme';

type DateInputProps = {
  readonly isError?: boolean;
};

export const InputWrapper = styled.div`
  max-width: 100%;
`;

export const LabelStyled = styled.label`
  width: 170px;
  display: inline-block;
  text-transform: capitalize;
  ${fonts.font1.H13B}
`;

export const DateInputStyled = styled.input<DateInputProps>`
  type="date";
  border: 1px solid ${({ isError }) => (isError ? colours.colour18 : colours.colour23)};
  border-radius: 4px;
  padding: 0.5rem;
`;

export const ErrorWrapper = styled.div`
  margin-bottom: 0.35rem;
  color: ${colours.colour18};
  ${fonts.font1.H14B};
`;
